import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton
} from '@mui/material';
import { faSpinner, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import { CloseIcon } from '../Icons/CommonIcons';
import { OrgUserType } from './OrgUserType.model';
import { OrgUserContext } from './OrgUserContext';
import { deleteUser } from '@/client/organization';
import { OrgContext } from '../Organizations/OrgContext';

interface DeleteOrgUserProps {
  isOpen: boolean;
  currentOrgUser: OrgUserType;
  setCurrentOrgUser: (setCurrentOrgUser: OrgUserType) => void;

  setIsOpen: (isOpen: boolean) => void;
}

const DeleteOrgUserModal = ({ setIsOpen, isOpen, currentOrgUser }: DeleteOrgUserProps) => {
  const form = useForm();
  const [isLoading, setIsSubmitting] = useState<boolean>(false);

  const { setGqlQueryOrgs } = useContext(OrgUserContext);
  const { setQueryOrgs } = useContext(OrgContext);
  const { handleSubmit } = form;

  const onSubmit = async () => {
    setIsSubmitting(true);
    try {
      await deleteUser(currentOrgUser.id);
      setIsSubmitting(false);
      setGqlQueryOrgs(true);
      setQueryOrgs(true);
    } catch (err) {
      console.log({ err });
      setIsSubmitting(false);
    }
    setIsOpen(false);
  };

  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)} maxWidth={'md'} fullWidth={true}>
      <DialogTitle>
        <div className="text-[24px] font-bold mb-[16px]">
          Delete User
          <IconButton
            aria-label="close"
            onClick={() => setIsOpen(false)}
            sx={{
              position: 'absolute',
              right: 28,
              top: 28
            }}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <div className="text-[18px] font-bold mb-[14px]">
          Are you sure you want to delete this user?
        </div>
      </DialogTitle>
      <DialogContent className="scrollContainer">
        {currentOrgUser && (
          <form noValidate>
            <div className="flex justify-between mb-[36px]">
              <span className="w-[360px]">
                <DialogContentText className="text-black">Name</DialogContentText>
                <DialogContentText className="text-black text-[18px] mb-[32px]">
                  {currentOrgUser.username}
                </DialogContentText>
              </span>
              <span className="w-[360px]">
                <DialogContentText className="text-black">Email</DialogContentText>
                <DialogContentText className="text-black text-[18px] mb-[32px]">
                  {currentOrgUser.email}
                </DialogContentText>
              </span>
            </div>
          </form>
        )}
      </DialogContent>
      <DialogActions>
        <button className="btn btn-neutral mr-[5px]" onClick={() => setIsOpen(false)}>
          Cancel
        </button>{' '}
        <button
          className="btn btn-primary"
          type="submit"
          onClick={handleSubmit(onSubmit)}
          disabled={isLoading}
        >
          <FontAwesomeIcon
            icon={isLoading ? faSpinner : faTrash}
            spin={isLoading}
            className="mr-8"
          />
          Delete
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteOrgUserModal;
